import React from 'react';
import FilesWithReferenceFiles from './FilesWithReferenceFiles';
var Tables = function Tables(_ref) {
  var apiRoot = _ref.apiRoot,
    methods = _ref.methods;
  return /*#__PURE__*/React.createElement(FilesWithReferenceFiles, {
    apiRoot: apiRoot,
    className: "order-figures",
    heading: "Your table files",
    subheading: "table-files-summary",
    methods: methods,
    types: {
      main: 'tables',
      reference: 'tablesRef'
    },
    names: {
      main: 'tableFiles',
      reference: 'tableReferenceFiles'
    }
  });
};
export default Tables;